{
    "app": {
        "name": "Development Bank — Customer Experience",
        "short_name": "DB-CX",
        "loading": "Loading",
        "tagline": "One customer. One record. One conversation."
    },
    "actions": {
        "save": "Save",
        "save_changes": "Save changes",
        "cancel": "Cancel",
        "close": "Close",
        "create": "Create",
        "edit": "Edit",
        "delete": "Delete",
        "remove": "Remove",
        "search": "Search",
        "filter": "Filter",
        "filters": "Filters",
        "clear": "Clear",
        "clear_filters": "Clear filters",
        "apply": "Apply",
        "reset": "Reset",
        "export": "Export",
        "export_csv": "Export as CSV",
        "export_excel": "Export as Excel",
        "export_pdf": "Export as PDF",
        "refresh": "Refresh",
        "retry": "Try again",
        "back": "Back",
        "next": "Next",
        "previous": "Previous",
        "confirm": "Confirm",
        "view": "View",
        "view_all": "View all",
        "select_all": "Select all",
        "upload": "Upload",
        "download": "Download",
        "copy": "Copy",
        "copied": "Copied",
        "show": "Show",
        "hide": "Hide",
        "reveal": "Reveal",
        "more": "More",
        "actions": "Actions",
        "all": "All"
    },
    "state": {
        "loading": "Loading…",
        "saving": "Saving…",
        "empty_title": "Nothing to show",
        "empty_description": "There are no records matching your filters.",
        "empty_no_filters": "There is nothing here yet.",
        "error_title": "Something went wrong",
        "error_description": "We could not load this. Please try again.",
        "offline": "You appear to be offline.",
        "no_results": "No results found",
        "no_results_for": "No results for “{{query}}”",
        "unauthorised_title": "You do not have access to this",
        "unauthorised_description": "Ask your administrator if you believe this is a mistake."
    },
    "table": {
        "showing": "Showing {{from}}–{{to}} of {{total}}",
        "per_page": "Per page",
        "page": "Page",
        "of_pages": "of {{total}}",
        "selected_one": "{{count}} selected",
        "selected_other": "{{count}} selected",
        "sort_ascending": "Sort ascending",
        "sort_descending": "Sort descending",
        "columns": "Columns",
        "density": "Density",
        "bulk_actions": "Bulk actions"
    },
    "time": {
        "just_now": "Just now",
        "today": "Today",
        "yesterday": "Yesterday",
        "tomorrow": "Tomorrow",
        "this_week": "This week",
        "last_7_days": "Last 7 days",
        "last_30_days": "Last 30 days",
        "this_month": "This month",
        "last_month": "Last month",
        "this_quarter": "This quarter",
        "this_year": "This year",
        "custom_range": "Custom range",
        "from": "From",
        "to": "To",
        "hijri": "Hijri",
        "gregorian": "Gregorian"
    },
    "language": {
        "label": "Language",
        "arabic": "العربية",
        "english": "English",
        "switch_to_arabic": "التبديل إلى العربية",
        "switch_to_english": "Switch to English"
    },
    "theme": {
        "label": "Appearance",
        "light": "Light",
        "dark": "Dark",
        "system": "System"
    },
    "masked": {
        "hidden": "Hidden for privacy",
        "reveal_prompt": "Reveal this value?",
        "reveal_warning": "Revealing sensitive data is recorded in the audit trail against your name.",
        "reveal_reason": "Reason (optional)"
    },
    "units": {
        "minutes": "min",
        "seconds": "s",
        "hours": "h",
        "days": "days",
        "currency_omr": "OMR"
    },
    "days": {
        "sunday": "Sunday",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday"
    },
    "boolean": {
        "yes": "Yes",
        "no": "No"
    },
    "priority": {
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "critical": "Critical"
    }
}
